export default function Disconnected() {
  return <p className="center">Connecting to the server...</p>
}